/**
 * Shop portal login body for `/portal-auth/login`.
 * Always pins `role: 'shop'` so a same-username cashier cannot win auth
 * when the shared portal endpoint would otherwise try cashier first.
 */
export function buildShopPortalLoginBody(payload: {
  loginId: string;
  password: string;
  captchaToken?: string;
}): {
  loginId: string;
  password: string;
  captchaToken?: string;
  role: 'shop';
} {
  return {
    ...payload,
    role: 'shop',
  };
}
